import { render, staticRenderFns } from "./MxPage.vue?vue&type=template&id=fc9b8296&scoped=true&"
import script from "./MxPage.vue?vue&type=script&lang=js&"
export * from "./MxPage.vue?vue&type=script&lang=js&"
import style0 from "./MxPage.vue?vue&type=style&index=0&id=fc9b8296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9b8296",
  null
  
)

export default component.exports